import { createSlice } from '@reduxjs/toolkit';
import { apiCallBegan } from './api';


const slice = createSlice({
  name: 'paxSearch',
  initialState: {
    profile: {},
    loading: false,
  },

  reducers: {
    profileRequested: (state, action) => {
      state.loading = true;
    },

    profileSuccess: (state, action) => {
      state.profile = action.payload;
      state.loading = false;
    },

    profileError: (state, action) => {
      state.loading = false;
      console.log(`profile pax err: ${action.payload}`);
    },

  }
})

// NOTE // actions for use in api requests
const { profileSuccess, profileError, profileRequested } = slice.actions;

// NOTE // actions for use in components
export default slice.reducer;

export const getProfile = () => (dispatch) => {
  const url = `users/me`

  return dispatch(
    apiCallBegan({
      url,
      method: 'get',
      onStart: profileRequested.type,
      onSuccess: profileSuccess.type,
      onError: profileError.type,
    })
  )
}

export const changePassword = (payload) => (dispatch) => {
  const url = `paxSearch/pnr`

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      data: payload,
      // onStart: searchRequested.type,
      // onSuccess: searchSuccess.type,
      // onError: searchError.type,
    })
  )
}